<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CREATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>
        {{ isUpdate ? `Cập nhật phiếu điều chuyển ${billNumber}` : 'Thêm phiếu điều chuyển' }}
      </h1>
      <div class="float-right btn-group">
        <button type="button" class="font-medium btn btn-outline-secondary" @click="requestItem()">
          <span v-if="currentStep === 1"><i class="bx bx-save"></i> Tiếp tục</span>
          <span v-else><i class="bx bx-save"></i> {{ isUpdate ? 'Lưu' : 'Tạo' }}</span>
        </button>
        <button
          v-if="currentStep === 2"
          type="button"
          class="font-medium btn btn-outline-secondary"
          @click="currentStep = 1"
        >
          <i class="bx bx-exit"></i> Quay lại
        </button>
        <button
          type="button"
          class="font-medium btn btn-outline-secondary"
          @click="$router.push('/transfer-warehouse')"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <ValidationObserver ref="inventoryRef" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(requestItem)">
          <div class="px-20 mt-2 card-body row" v-if="currentStep === 1">
            <div class="col-md-6">
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"> Ngày lập phiếu </label>
                <div class="col-sm-7">
                  <input v-if="isUpdate" v-model="dateCreate" disabled />
                  <datepicker
                    format="dd/MM/yyyy"
                    v-else
                    :language="vi"
                    v-model="createdDate"
                    v-once
                    disabled
                  >
                  </datepicker>
                </div>
              </div>
              <div class="form-group row" v-if="isUpdate">
                <label class="col-sm-3 col-form-label"> Số phiếu </label>
                <div class="col-sm-7">
                  <input
                    disabled
                    v-model.trim="dataAdd.billNumber"
                    type="text"
                    class="form-control"
                    placeholder="Số phiếu"
                  />
                </div>
              </div>
              <ValidationProvider rules="required" vid="dateTransfer" name="Ngày chuyển">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Ngày chuyển <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataAdd.dateTransfer"
                      placeholder="Ngày chuyển"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="cityCode" name="Lý do chuyển">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-3 col-form-label">
                    Lý do chuyển <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-7">
                    <select
                      @change="onChangeReason"
                      v-model="dataAdd.reasonTransfer"
                      class="form-control"
                      placeholder="Lý do chuyển"
                    >
                      <option v-for="re in reasonTransferData" :key="re.id" :value="re.id">
                        {{ re.text }}
                      </option>
                    </select>
                    <p v-if="hintReasonTransfer" class="text-info">
                      {{ hintReasonTransfer }}
                    </p>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="inventoryIdExport" name="Kho/ NV chuyển">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Chuyển từ kho <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-7">
                    <Select2
                      @change="onChangeWarehouseExport"
                      placeholder="Kho/ NV chuyển"
                      v-model="dataAdd.inventoryIdExport"
                      :options="warehouseUserActiveData"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="inventoryIdImport" name="Kho/ NV nhận">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Đến kho <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-7">
                    <Select2
                      placeholder="Kho/ NV nhận"
                      v-model="dataAdd.inventoryIdImport"
                      :options="warehouseActiveData"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="minMaxName_4" vid="description" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-3 col-form-label">Ghi chú</label>
                  <div class="col-sm-7">
                    <input
                      v-model.trim="dataAdd.description"
                      type="text"
                      class="form-control"
                      placeholder="Ghi chú"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <button type="submit" v-show="false"></button>
            </div>
          </div>
          <div class="mx-5 card-body" v-else-if="currentStep === 2">
            <h3 class="text-center mb-3">PHIẾU ĐIỀU CHUYỂN</h3>
            <p class="f14 text-center" v-if="isUpdate">Số phiếu: {{ dataAdd.billNumber }}</p>
            <p class="f14 text-center">Ngày chuyển: {{ dataAdd.dateTransfer | formatDate }}</p>
            <div class="row mt-4">
              <div class="col-md-6">
                <p class="f14">
                  Chuyển từ kho:
                  {{ dataAdd.inventoryIdExport | transformData(warehouseUserActiveData) }}
                </p>
                <p class="f14 my-1">
                  Lý do chuyển:
                  {{ dataAdd.reasonTransfer | transformData(Config.reasonTransferWarehouse) }}
                </p>
                <p class="f14">Ghi chú: {{ dataAdd.description }}</p>
              </div>
              <div class="col-md-6">
                <p class="f14">
                  Đến kho:
                  {{ dataAdd.inventoryIdImport | transformData(warehouseActiveData) }}
                </p>
              </div>
            </div>
            <div class="p-0 pt-2 card">
              <div
                class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
              >
                <h1 class="mb-1 form-inner-heading">Danh sách thiết bị điều chuyển</h1>
                <div class="float-right btn-group">
                  <button
                    type="button"
                    @click="deleteDeviceMul"
                    v-if="selected.length > 0"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-minus-circle"></i> Xoá
                  </button>
                  <button
                    type="button"
                    @click="showAddMaterial"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bxs-plus-circle"></i> Chọn vật tư
                  </button>
                  <button
                    type="button"
                    @click="exportTemplateTransferWarehouse"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-download"></i> Tải file mẫu
                  </button>
                  <button
                    type="button"
                    @click="$refs.uploadFileExcel.click()"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-upload"></i> import file
                  </button>
                  <button
                    type="button"
                    @click="showAddDevice"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bxs-plus-circle"></i> Chọn thiết bị
                  </button>
                  <input
                    style="display: none"
                    ref="uploadFileExcel"
                    @change="uploadFileExcel"
                    type="file"
                  />
                </div>
              </div>
              <div class="tab-content">
                <div
                  class="table-responsive b-table-sticky-header"
                  style="overflow: auto; max-height: 70vh"
                >
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr class="text-center">
                        <th>
                          <input type="checkbox" v-model="selectAll" />
                        </th>
                        <th class="text-left">Tên loại thiết bị</th>
                        <th>Số lượng</th>
                        <th>Mã Serial</th>
                        <th>DVT</th>
                        <th>Tình trạng</th>
                        <th>Ghi chú</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="table-row text-center"
                        v-for="(device, index) in dataAdd.devices"
                        :key="`device${index}`"
                      >
                        <td>
                          <input type="checkbox" v-model="selected" :value="device" />
                        </td>
                        <td class="text-left">
                          {{ device.text ? device.text : device.categoryName }}
                        </td>
                        <td>{{ device.quantity ? device.quantity : '1' }}</td>
                        <td>{{ device.serial }}</td>
                        <td>
                          {{ device.unit | transformData(Config.unitDevice) }}
                        </td>
                        <td>
                          <span class="badge" :class="[device.type || '']">
                            {{ device.type | transformData(Config.stateDevices) }}
                          </span>
                        </td>
                        <td>
                          <ValidationProvider rules="minMaxName_4" :vid="device.id" name="Ghi chú">
                            <template slot-scope="{ errors }">
                              <input
                                v-model.trim="device.noteExport"
                                type="text"
                                class="form-control"
                                placeholder="Ghi chú"
                              />
                              <p class="text-danger">{{ errors[0] }}</p>
                            </template>
                          </ValidationProvider>
                        </td>
                        <td>
                          <b-button
                            type="button"
                            size="md"
                            variant="danger"
                            @click="deleteDevice(index)"
                          >
                            Xoá
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <button type="submit" v-show="false"></button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push('/transfer-warehouse')"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <b-modal
      id="modal-noti"
      centered
      v-model="modalChooseDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>Chọn thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <form @submit.prevent="filterDevice" class="box-search">
        <div class="form-group">
          <Select2
            placeholder="Loại thiết bị"
            v-model="searchDevice.text"
            :options="deviceCatData"
          />
        </div>
        <div class="form-group" v-if="isAll === true">
          <input
            v-model.trim="searchDevice.numberGear"
            type="text"
            class="form-control"
            placeholder="Số thùng"
          />
        </div>
        <div class="form-group">
          <input
            v-model.trim="searchDevice.serial"
            type="text"
            class="form-control"
            placeholder="Mã serial"
          />
        </div>
        <div class="form-group form-group-action d-flex" style="gap: 5px">
          <button type="submit" class="font-medium btn btn-outline-secondary" @click="filterDevice">
            Lọc
          </button>
          <button
            type="buton"
            @click="unFilterDevice"
            class="font-medium btn btn-outline-secondary"
          >
            Bỏ lọc
          </button>
        </div>
      </form>
      <div class="table-responsive b-table-sticky-header">
        <div style="max-height: 400px; overflow: auto">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr class="text-center">
                <th>
                  <input type="checkbox" v-model="selectAllDevice" />
                </th>
                <th>Loại thiết bị</th>
                <th>Mã Serial</th>
                <th>DVT</th>
                <th>Tình trạng</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row text-center"
                v-for="(device, index) in dataMaterial"
                :key="`dataMaterial${index}`"
              >
                <td>
                  <input id="checkbox" type="checkbox" v-model="selectedDevice" :value="device" />
                </td>
                <td class="text-left">{{ device.text }}</td>
                <td>{{ device.serial }}</td>
                <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                <td>
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevice" size="md" variant="primary"> Thêm </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <modalAddMaterial
      v-if="isShowAddMaterial"
      @updateStatus="updateStatus"
      :dataMaterial="dataMaterial"
      @onHidden="onHidden"
    />
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import cloneDeep from 'lodash/cloneDeep'
  import filter from 'lodash/filter'
  import includes from 'lodash/includes'
  import differenceBy from 'lodash/differenceBy'
  import Config from '../../../thirdParty/config'
  import modalAddMaterial from './modalAddMaterial.vue'

  export default {
    name: 'add-transfer-warehouse',
    data() {
      return {
        Config,
        billNumber: '',
        isUpdate: false,
        createdDate: new Date().getTime(),
        dataAdd: {
          dateCreate: new Date().getTime(),
          dateTransfer: new Date().getTime(),
          reasonTransfer: 'TRANSFER_INTERNAL',
          devices: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        showModalNoti: false,
        keyCheck: 'cancel',
        messNoti: '',
        srcImage: '',
        vi: vi,
        selected: [],
        selectedDevice: [],
        reasonTransferData: Config.reasonTransferWarehouse.filter(
          s => s.id !== 'TRANSFER_ECOMMERCE' && s.id !== 'TRANSFER_AGENCY'
        ),
        modalChooseDevice: false,
        warehouseUserActiveData: [],
        warehouseUserActiveDataOriginal: [], // Thêm biến để lưu dữ liệu gốc
        warehouseActive: [],
        warehouseActiveData: [],
        deviceData: [],
        deviceFilterData: [],
        deviceCatData: [],
        currentStep: 1,
        searchDevice: {},
        isAll: false,
        hintReasonTransfer: null,
        dataMaterial: [],
        dataFilter: [],
        isShowAddMaterial: false,
        dateCreate: '',
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    components: {
      modalAddMaterial,
    },
    async created() {
      this.fetchCatDevice()
      await this.fetchWarehouse()
      await this.checkHasCoppy()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return this.dataAdd.devices ? this.selected.length === this.dataAdd.devices.length : false
        },
        set: function (value) {
          if (value) {
            this.selected = cloneDeep(this.dataAdd.devices)
          } else this.selected = []
        },
      },
      selectAllDevice: {
        get: function () {
          return this.dataMaterial ? this.selectedDevice.length === this.dataMaterial.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedDevice = cloneDeep(this.dataMaterial)
          } else this.selectedDevice = []
        },
      },
    },

    methods: {
      // onChangeReason(event) {
      //   this.dataAdd.devices = []
      //   if (event?.target?.value === 'TRANSFER_BROKEN')
      //     this.hintReasonTransfer =
      //       "Chỉ chọn lý do này khi thiết bị đã hỏng không bảo hành được, cần chuyển đi chờ hủy. Để chuyển thiết bị về kho bảo hành, chọn lý do: 'Điều chuyển thiết bị bảo hành'."
      //   else this.hintReasonTransfer = null

      //   console.log('warehouseUserActiveData',this.warehouseUserActiveData)
      // },
      // onChangeReason(event) {
      //   this.dataAdd.devices = []
      //   this.dataAdd.inventoryIdExport = null
      //   this.dataAdd.inventoryIdImport = null

      //   if (event?.target?.value === 'TRANSFER_BROKEN') {
      //     this.hintReasonTransfer =
      //       "Chỉ chọn lý do này khi thiết bị đã hỏng không bảo hành được, cần chuyển đi chờ hủy. Để chuyển thiết bị về kho bảo hành, chọn lý do: 'Điều chuyển thiết bị bảo hành'."
      //   } else {
      //     this.hintReasonTransfer = null
      //   }

      //   // Xử lý logic cho TRANSFER_RETURN_FROM_AGENT
      //   if (event?.target?.value === 'TRANSFER_RETURN_FROM_AGENT') {
      //     // Lọc kho chuyển chỉ hiển thị type = BANK hoặc BANK_DIGITAL
      //     this.warehouseUserActiveData = this.warehouseUserActiveData.filter(
      //       (item) => item.type === 'BANK' || item.type === 'BANK_DIGITAL'
      //     )
      //   } else {
      //     // Reset lại danh sách kho chuyển về ban đầu cho các lý do khác
      //     this.fetchWarehouse()
      //   }

      // },
      // onChangeWarehouseExport(id) {
      //   this.dataAdd.devices = []
      //   const data = this.warehouseUserActiveData.find((s) => s.id === id)
      //   if (!data) return
      //   const { level, regions, city } = data
      //   const regionsEqual = (arr1, arr2) => {
      //     return filter([...(arr1 ?? []), ...(arr2 ?? [])], (val, i, iteratee) =>
      //       includes(iteratee, val, i + 1)
      //     )
      //   }
      //   if (level !== 'ALL') {
      //     this.reasonTransferData = this.reasonTransferData.filter(
      //       (s) => s.id !== 'TRANSFER_BROKEN'
      //     )
      //     // this.dataAdd.reasonTransfer = null
      //     this.onChangeReason()
      //   }
      //   if (level === 'ALL') {
      //     this.reasonTransferData = Config.reasonTransferWarehouse
      //     this.isAll = true
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       return ['ALL', 'AREA', 'CITY', 'EMPLOYEE'].includes(s.level)
      //     })
      //   } else if (level === 'AREA') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (['ALL', 'AREA'].includes(s.level)) return true
      //       else if (['CITY', 'EMPLOYEE'].includes(s.level)) {
      //         return !!s.regions?.find((z) => regions.includes(z))
      //       } else return false
      //     })
      //   } else if (level === 'CITY') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (s.level === 'ALL') return true
      //       else if (
      //         ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       else return false
      //     })
      //   } else if (level === 'EMPLOYEE') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (
      //         this.dataUser.typeSale === 'SALE' &&
      //         s.level === 'EMPLOYEE' &&
      //         regionsEqual(s.city?.split(', '), city?.split(', '))
      //       )
      //         return true
      //       if (
      //         this.dataUser.typeSale === 'SALE' &&
      //         ['AREA', 'CITY'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       if (
      //         this.dataUser.typeSale !== 'SALE' &&
      //         ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       else return false
      //     })
      //   }
      //   if (this.dataUser.typeSale === 'SALE_ADMIN') {
      //     const moreData = this.warehouseUserActiveData.filter((s) => {
      //       if (s.id === id) return false
      //       if (this.warehouseActiveData.find((z) => z.id === s.id)) return false
      //       else return true
      //     })
      //     this.warehouseActiveData.push(...moreData)
      //   }
      //   this.warehouseActiveData = this.warehouseActiveData.filter(
      //     (item) => item.type !== 'MC_SELF_ONBOARD'
      //   )
      //   if (this.dataAdd.reasonTransfer === 'TRANSFER_AGENCY') {
      //     this.warehouseActiveData = this.warehouseActiveData.filter(
      //       (item) => item.type === 'AGENCY'
      //     )
      //   }
      // },

      // onChangeWarehouseExport(id) {

      //   this.dataAdd.devices = []
      //   const data = this.warehouseUserActiveData.find((s) => s.id === id)
      //   if (!data) return

      //   const { level, regions, city, type } = data

      //   // Xử lý đặc biệt cho lý do TRANSFER_RETURN_FROM_AGENT
      //   if (this.dataAdd.reasonTransfer === 'TRANSFER_RETURN_FROM_AGENT') {
      //     if (type === 'BANK_DIGITAL') {
      //       // Kho xuất type = BANK_DIGITAL => Kho nhận hiển thị type = EMPLOYEE
      //       this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //         if (s.id === id) return false
      //         return s.type === 'EMPLOYEE'
      //       })
      //     } else if (type === 'BANK') {
      //       // Kho xuất type = BANK => Kho nhận hiển thị level = AREA hoặc CITY
      //       this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //         if (s.id === id) return false
      //         return s.level === 'AREA' || s.level === 'CITY'
      //       })
      //     }
      //     return
      //   }

      //   // Logic cũ cho các lý do khác (giữ nguyên)
      //   const regionsEqual = (arr1, arr2) => {
      //     return filter([...(arr1 ?? []), ...(arr2 ?? [])], (val, i, iteratee) =>
      //       includes(iteratee, val, i + 1)
      //     )
      //   }

      //   if (level !== 'ALL') {
      //     this.reasonTransferData = this.reasonTransferData.filter(
      //       (s) => s.id !== 'TRANSFER_BROKEN'
      //     )
      //     this.onChangeReason()
      //   }

      //   if (level === 'ALL') {
      //     this.reasonTransferData = Config.reasonTransferWarehouse
      //     this.isAll = true
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       return ['ALL', 'AREA', 'CITY', 'EMPLOYEE'].includes(s.level)
      //     })
      //   } else if (level === 'AREA') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (['ALL', 'AREA'].includes(s.level)) return true
      //       else if (['CITY', 'EMPLOYEE'].includes(s.level)) {
      //         return !!s.regions?.find((z) => regions.includes(z))
      //       } else return false
      //     })
      //   } else if (level === 'CITY') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (s.level === 'ALL') return true
      //       else if (
      //         ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       else return false
      //     })
      //   } else if (level === 'EMPLOYEE') {
      //     this.isAll = false
      //     this.warehouseActiveData = this.warehouseActive.filter((s) => {
      //       if (s.id === id) return false
      //       if (
      //         this.dataUser.typeSale === 'SALE' &&
      //         s.level === 'EMPLOYEE' &&
      //         regionsEqual(s.city?.split(', '), city?.split(', '))
      //       )
      //         return true
      //       if (
      //         this.dataUser.typeSale === 'SALE' &&
      //         ['AREA', 'CITY'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       if (
      //         this.dataUser.typeSale !== 'SALE' &&
      //         ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
      //         regionsEqual(s.regions, regions)
      //       )
      //         return true
      //       else return false
      //     })
      //   }

      //   if (this.dataUser.typeSale === 'SALE_ADMIN') {
      //     const moreData = this.warehouseUserActiveData.filter((s) => {
      //       if (s.id === id) return false
      //       if (this.warehouseActiveData.find((z) => z.id === s.id)) return false
      //       else return true
      //     })
      //     this.warehouseActiveData.push(...moreData)
      //   }

      //   this.warehouseActiveData = this.warehouseActiveData.filter(
      //     (item) => item.type !== 'MC_SELF_ONBOARD'
      //   )

      //   if (this.dataAdd.reasonTransfer === 'TRANSFER_AGENCY') {
      //     this.warehouseActiveData = this.warehouseActiveData.filter(
      //       (item) => item.type === 'AGENCY'
      //     )
      //   }
      // },

      onChangeReason(event) {
        this.dataAdd.devices = []
        this.dataAdd.inventoryIdExport = null
        this.dataAdd.inventoryIdImport = null

        const selectedValue = event?.target?.value

        // Reset danh sách kho nhận
        this.warehouseActiveData = []

        // Reset reasonTransferData về trạng thái ban đầu
        this.reasonTransferData = Config.reasonTransferWarehouse.filter(
          s => s.id !== 'TRANSFER_ECOMMERCE' && s.id !== 'TRANSFER_AGENCY'
        )

        if (selectedValue === 'TRANSFER_BROKEN') {
          this.hintReasonTransfer =
            "Chỉ chọn lý do này khi thiết bị đã hỏng không bảo hành được, cần chuyển đi chờ hủy. Để chuyển thiết bị về kho bảo hành, chọn lý do: 'Điều chuyển thiết bị bảo hành'."
        } else {
          this.hintReasonTransfer = null
        }

        // Xử lý logic cho TRANSFER_RETURN_FROM_AGENT
        if (selectedValue === 'TRANSFER_RETURN_FROM_AGENT') {
          // Lọc kho chuyển chỉ hiển thị type = BANK hoặc BANK_DIGITAL
          this.warehouseUserActiveData = this.warehouseUserActiveDataOriginal.filter(
            item => item.type === 'BANK' || item.type === 'BANK_DIGITAL'
          )
        } else if (selectedValue === 'TRANSFER_CHANNEL') {
          this.warehouseUserActiveData = this.warehouseUserActiveDataOriginal.filter(
            item => item.level === 'ALL'
          )
        } else {
          // Reset lại danh sách kho chuyển về ban đầu cho các lý do khác
          this.warehouseUserActiveData = [...this.warehouseUserActiveDataOriginal]
        }

        // Clear validation errors
        this.$nextTick(() => {
          if (this.$refs.inventoryRef) {
            this.$refs.inventoryRef.reset()
          }
        })
      },

      onChangeWarehouseExport(id) {
        this.dataAdd.devices = []
        this.dataAdd.inventoryIdImport = null // Reset kho nhận khi thay đổi kho xuất

        const data = this.warehouseUserActiveData.find(s => s.id === id)
        if (!data) return

        const { level, regions, city, type, channel } = data

        if (this.dataAdd.reasonTransfer === 'TRANSFER_CHANNEL') {
          this.warehouseActiveData = this.warehouseUserActiveDataOriginal.filter(
            item => item.level === 'ALL' && item.channel !== channel
          )
          return
        }

        // Xử lý đặc biệt cho lý do TRANSFER_RETURN_FROM_AGENT
        if (this.dataAdd.reasonTransfer === 'TRANSFER_RETURN_FROM_AGENT') {
          if (type === 'BANK_DIGITAL') {
            // Kho xuất type = BANK_DIGITAL => Kho nhận hiển thị type = EMPLOYEE
            this.warehouseActiveData = this.warehouseActive.filter(s => {
              if (s.id === id) return false
              return s.type === 'EMPLOYEE'
            })
          } else if (type === 'BANK') {
            // Kho xuất type = BANK => Kho nhận hiển thị level = AREA hoặc CITY
            this.warehouseActiveData = this.warehouseActive.filter(s => {
              if (s.id === id) return false
              return s.level === 'AREA' || s.level === 'CITY'
            })
          }

          // Clear validation errors cho kho nhận với TRANSFER_RETURN_FROM_AGENT
          this.$nextTick(() => {
            if (this.$refs.inventoryRef) {
              // Clear specific field error
              const observer = this.$refs.inventoryRef
              if (observer && observer.setErrors) {
                observer.setErrors({
                  inventoryIdImport: [],
                })
              }
            }
          })
          return
        }

        // Logic cũ cho các lý do khác (giữ nguyên tất cả)
        const regionsEqual = (arr1, arr2) => {
          return filter([...(arr1 ?? []), ...(arr2 ?? [])], (val, i, iteratee) =>
            includes(iteratee, val, i + 1)
          )
        }

        if (level !== 'ALL') {
          this.reasonTransferData = this.reasonTransferData.filter(s => s.id !== 'TRANSFER_BROKEN')
          // Nếu lý do hiện tại là TRANSFER_BROKEN, reset về lý do mặc định
          if (this.dataAdd.reasonTransfer === 'TRANSFER_BROKEN') {
            this.dataAdd.reasonTransfer = 'TRANSFER_INTERNAL'
          }
        }

        if (level === 'ALL') {
          this.reasonTransferData = Config.reasonTransferWarehouse.filter(
            s => s.id !== 'TRANSFER_ECOMMERCE' && s.id !== 'TRANSFER_AGENCY'
          )
          this.isAll = true
          this.warehouseActiveData = this.warehouseActive.filter(s => {
            if (s.id === id) return false
            return ['ALL', 'AREA', 'CITY', 'EMPLOYEE'].includes(s.level)
          })
        } else if (level === 'AREA') {
          this.isAll = false
          this.warehouseActiveData = this.warehouseActive.filter(s => {
            if (s.id === id) return false
            if (['ALL', 'AREA'].includes(s.level)) return true
            else if (['CITY', 'EMPLOYEE'].includes(s.level)) {
              return !!s.regions?.find(z => regions.includes(z))
            } else return false
          })
        } else if (level === 'CITY') {
          this.isAll = false
          this.warehouseActiveData = this.warehouseActive.filter(s => {
            if (s.id === id) return false
            if (s.level === 'ALL') return true
            else if (
              ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
              regionsEqual(s.regions, regions)
            )
              return true
            else return false
          })
        } else if (level === 'EMPLOYEE') {
          this.isAll = false
          this.warehouseActiveData = this.warehouseActive.filter(s => {
            if (s.id === id) return false
            if (
              this.dataUser.typeSale === 'SALE' &&
              s.level === 'EMPLOYEE' &&
              regionsEqual(s.city?.split(', '), city?.split(', '))
            )
              return true
            if (
              this.dataUser.typeSale === 'SALE' &&
              ['AREA', 'CITY'].includes(s.level) &&
              regionsEqual(s.regions, regions)
            )
              return true
            if (
              this.dataUser.typeSale !== 'SALE' &&
              ['AREA', 'CITY', 'EMPLOYEE'].includes(s.level) &&
              regionsEqual(s.regions, regions)
            )
              return true
            else return false
          })
        }

        if (this.dataUser.typeSale === 'SALE_ADMIN') {
          const moreData = this.warehouseUserActiveData.filter(s => {
            if (s.id === id) return false
            if (this.warehouseActiveData.find(z => z.id === s.id)) return false
            else return true
          })
          this.warehouseActiveData.push(...moreData)
        }

        this.warehouseActiveData = this.warehouseActiveData.filter(
          item => item.type !== 'MC_SELF_ONBOARD'
        )

        if (this.dataAdd.reasonTransfer === 'TRANSFER_AGENCY') {
          this.warehouseActiveData = this.warehouseActiveData.filter(item => item.type === 'AGENCY')
        }

        // Clear validation errors cho kho nhận cho tất cả các trường hợp
        this.$nextTick(() => {
          if (this.$refs.inventoryRef) {
            const observer = this.$refs.inventoryRef
            if (observer && observer.setErrors) {
              observer.setErrors({
                inventoryIdImport: [],
              })
            }
          }
        })
      },
      async checkHasCoppy() {
        if (this.$route.params.coppyFrom || this.$route.params.entryId) {
          if (this.$route.params.entryId) {
            this.isUpdate = true
          }
          this.loading = true
          const res = await DeviceService.detailTransferWarehouse(
            this.$route.params.coppyFrom ?? this.$route.params.entryId
          )
          if (res.code === 1000) {
            this.onChangeWarehouseExport(res.data.inventoryIdExport)
            this.billNumber = res.data.billNumber
            const listCopy = {
              dateCreate: res.data.dateCreate,
              billNumber: res.data.billNumber,
              dateTransfer: res.data.timeExport,
              inventoryIdExport: res.data.inventoryIdExport,
              inventoryNameExport: res.data.inventoryNameExport,
              inventoryIdImport: res.data.inventoryIdImport,
              inventoryNameImport: res.data.inventoryNameImport,
              reasonTransfer: res.data.reasonTransfer,
              description: res.data.description,
              devices: res.data.devices.map(s => {
                return {
                  ...s,
                  note: s.noteExport,
                }
              }),
            }
            this.dateCreate = this.formatTimestamp(res.data.dateCreate)
            this.dataAdd = listCopy
          }
          this.loading = false
        }
      },
      // async fetchWarehouse() {
      //   const response = await DeviceService.getListWarehouseUserActive()
      //   this.warehouseUserActiveData = response.data.map(
      //     ({ id, name, level, type, regions, cityCode }) => {
      //       return { id, text: name, level, type, regions, cityCode }
      //     }
      //   )

      //   // this.warehouseUserActiveData = this.warehouseUserActiveData.filter((item) => item.type !== 'MC_SELF_ONBOARD')

      //   const res = await DeviceService.getListWarehouseActive()
      //   this.warehouseActive = res.data.map(
      //     ({ id, name, level, type, regions, code, cityCode }) => {
      //       return { id, text: name, type, level, regions, code, cityCode }
      //     }
      //   )
      // },
      async fetchWarehouse() {
        const response = await DeviceService.getListWarehouseUserActive()
        this.warehouseUserActiveData = response.data.map(
          // ({ id, name, level, type, regions, cityCode }) => {
          //   return { id, text: name, level, type, regions, cityCode }
          // }
          ({ name, ...item }) => {
            return {
              ...item,
              text: name,
            }
          }
        )

        // Lưu dữ liệu gốc để có thể reset khi cần
        this.warehouseUserActiveDataOriginal = [...this.warehouseUserActiveData]

        const res = await DeviceService.getListWarehouseActive()
        this.warehouseActive = res.data.map(
          ({ id, name, level, type, regions, code, cityCode }) => {
            return { id, text: name, type, level, regions, code, cityCode }
          }
        )
      },
      async fetchCatDevice() {
        const response = await DeviceService.typeDeviceConfig()
        this.deviceCatData = response.data.map(({ name }) => {
          return { id: name, text: name }
        })
      },
      async fetchDeviceByInventory() {
        this.loading = true
        const response = await DeviceService.listDeviceByInventory({
          inventoryId: this.dataAdd.inventoryIdExport,
          reason: this.dataAdd.reasonTransfer,
          kind: 'SERIAL',
        })
        this.deviceFilterData = response.data
        this.dataMaterial = response.data.map(item => {
          return {
            id: item.id,
            text: item.categoryName,
            serial: item.serial,
            type: item.type,
            unit: item.unit,
          }
        })
        this.dataFilter = this.dataMaterial
        this.loading = false
      },
      unFilterDevice() {
        this.searchDevice = {}
        this.fetchDeviceByInventory()
      },
      async filterDevice() {
        const deviceData = this.dataFilter.filter(s => {
          const rules = []
          if (this.searchDevice.serial) {
            rules.push(s.serial.toLowerCase().indexOf(this.searchDevice.serial.toLowerCase()) > -1)
          }
          if (this.searchDevice.numberGear) {
            rules.push(
              s.numberGear.toLowerCase().indexOf(this.searchDevice.numberGear.toLowerCase()) > -1
            )
          }
          if (this.searchDevice.text) {
            rules.push(s.text === this.searchDevice.text)
          }
          return !rules.includes(false)
        })
        this.dataMaterial = deviceData
      },
      async requestItem() {
        const isSuccess = await this.$refs.inventoryRef.validate()
        if (!isSuccess) {
          return
        }
        if (this.currentStep === 2) {
          if (this.dataAdd.devices.length === 0) {
            this.showErr('Danh sách thiết bị không được bỏ trống')
            return
          }
          try {
            this.loading = true
            const params = cloneDeep(this.dataAdd)
            params.id = this.$route.params.entryId
            params.dateTransfer = new Date(params.dateTransfer).getTime()
            params.typeImport = 'IMPORT_FILE'
            params.inventoryNameExport = this.$options.filters.transformData(
              params.inventoryIdExport,
              this.warehouseUserActiveData
            )
            params.inventoryNameImport = this.$options.filters.transformData(
              params.inventoryIdImport,
              this.warehouseActive
            )
            delete params.billNumber
            delete params.dateCreate
            let response = {}
            if (this.isUpdate) {
              params.devices = params.devices.map(
                ({ id, note, serial, kind, quantity, categoryName }) => {
                  if (kind === 'NORMAL' && quantity) {
                    return { id, note, kind, quantity, categoryName }
                  } else return { id, note, serial, categoryName }
                }
              )
              response = await DeviceService.updateTransferWarehouse(params)
            } else {
              params.devices = params.devices.map(({ id, note, serial, kind, quantity }) => {
                if (kind && quantity) {
                  return { id, note, kind, quantity }
                } else return { id, note, serial }
              })
              response = await DeviceService.createTransferWarehouse(params)
            }
            if (response.code === 1000) {
              this.keyCheck = 'accept'
              this.showSuccess(
                this.isUpdate
                  ? 'Cập nhật phiếu điều chuyển thành công !'
                  : 'Thêm phiếu điều chuyển thành công !'
              )
            } else if (response.code === 1025 || response.code === 1039 || response.code === 1042) {
              this.keyCheck = 'addLead'
              this.showErr(response.message)
            } else {
              this.keyCheck = 'cancel'
              this.showErr(response.message)
            }
          } catch (error) {
            if (error.message) this.showErr(error.message)
            console.log(error)
          } finally {
            this.loading = false
          }
          return
        }
        // await this.fetchDeviceByInventory()
        this.currentStep++
      },
      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices.splice(index, 1)
            }
          })
      },
      deleteDeviceMul() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá những thiết bị đã được chọn trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices = differenceBy(this.dataAdd.devices, this.selected, 'id')
              this.selected = []
            }
          })
      },
      async requestDevice() {
        const arr = [...this.selectedDevice, ...this.dataAdd.devices]
        this.dataAdd.devices = this.getUnique(arr, 'id')
        this.modalChooseDevice = false
        this.selectedDevice = []
      },
      async exportTemplateTransferWarehouse() {
        try {
          this.loading = true
          await DeviceService.exportTemplateTransferWarehouse()
        } finally {
          this.loading = false
        }
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await DeviceService.exportDeviceExcelTransferWarehouse(reqs)
        } finally {
          this.loading = false
        }
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showErr('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        formdata.append('inventoryId', this.dataAdd.inventoryIdExport)
        try {
          this.loading = true
          const res = await DeviceService.importDeviceExcelTransferWarehouse(formdata)
          if (res.code === 1000) {
            const arr = [...res.data.correctList, ...this.dataAdd.devices]
            this.dataAdd.devices = this.getUnique(arr, 'id')
            this.showMsgOk(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showErr(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showErr(res.res[0].message)
          } else {
            this.showErr(res.message)
          }
        } catch (e) {
          this.showErr(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.loading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.correctList.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.errorList.length),
            ' bản ghi',
          ]),
          data.errorList.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.errorList),
                },
              },
              'Tải bản ghi thất bại'
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      getUnique(arr, comp) {
        const unique = arr
          .map(e => e[comp])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => arr[e])
          .map(e => arr[e])

        return unique
      },
      updateStatus(data) {
        this.dataAdd.devices.push(data)
        this.$bvModal.hide('add-material')
        this.isShowAddMaterial = false
      },
      showAddMaterial() {
        this.isShowAddMaterial = true
        this.fetchDevice('NORMAL')
        this.$nextTick(() => {
          this.$bvModal.show('add-material')
        })
      },
      showAddDevice() {
        // this.modalChooseDevice = true
        this.fetchDeviceByInventory()
        this.$nextTick(() => {
          this.$bvModal.show('modal-noti')
        })
      },
      async fetchDevice(kind) {
        try {
          this.loading = true
          const params = {
            kind: kind,
            inventoryIds: [this.dataAdd.inventoryIdExport],
          }
          const response = await DeviceService.listDevice(params)
          this.dataMaterial = response.data.devices.map(item => {
            return {
              id: item.id,
              text: item.categoryName,
              serial: item.serial,
              type: item.type,
              unit: item.unit,
            }
          })
          this.dataFilter = this.dataMaterial
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      onHidden() {
        this.isShowAddMaterial = false
      },
      formatTimestamp(timestamp) {
        const date = new Date(timestamp)
        const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
        return formattedDate
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .form-control-label {
    display: flex !important;
    align-items: center !important;
  }

  #checkbox {
    min-height: 13px;
    min-width: 13px;
  }
</style>
